import React from 'react';
import styles from './SGSNavMenu.module.scss';
import classnames from 'classnames';
import { Menu } from 'core/models';
import { Box, Collapse } from '@material-ui/core';
import { useHistory } from 'react-router';

type Props = {
    menu: Menu;
    className?: string;
    onClick?: Function;
    collapseHandler?: Function;
};

const SGSNavMenu: React.FC<Props> = ({ menu, className, onClick, collapseHandler = () => null }) => {
    const {
        location: { pathname },
    } = useHistory();
    // Menu is active if the menu is the current path of if one of his subitems is the current path
    const isMenuActive =
        (menu.path === '/' && menu.path === pathname) || (menu.path !== '/' && (pathname.startsWith(menu.path) || (menu.menuItems ?? []).findIndex((m) => pathname.startsWith(m.path)) !== -1));

    return (
        <>
            {/* global */}
            <div className={classnames(styles.navMenuContainer, className)}>
                {/* header */}
                <div
                    className={classnames(styles.navMenu, isMenuActive && styles.navMenuActive)}
                    onClick={() => {
                        if (menu.menuItems && menu.menuItems.length > 0) {
                            collapseHandler();
                        } else {
                            onClick(menu);
                        }
                    }}
                >
                    {/* icone + texte */}
                    <div className="d-flex align-items-center">
                        {/* icone */}
                        <div className={styles.navMenuBadge}>
                            <img src={menu.icon} alt={menu.name} className={styles.image} />
                        </div>
                        {/* texte */}
                        <div className={styles.navMenuLabel}>{menu.name}</div>
                    </div>
                    {/* collapse si besoin */}
                    {menu.menuItems && menu.menuItems.length > 0 && (
                        <div>
                            <Box component="span" className={classnames('fas fa-angle-down', styles.collapseIcon, !menu.collapsed && styles.menuOpened)} />
                        </div>
                    )}
                </div>
                {/* sous items */}
                {menu.menuItems && menu.menuItems.length > 0 && (
                    <Collapse in={!menu.collapsed} timeout="auto" unmountOnExit>
                        {menu.menuItems.map((o: Menu) => (
                            <div key={o.name} className={classnames(styles.navSubMenuLabel, pathname === o.path && styles.navSubMenuLabelActive)} onClick={() => onClick(o)}>
                                {o.name}
                            </div>
                        ))}
                        <div></div>
                    </Collapse>
                )}
            </div>
        </>
    );
};

export default SGSNavMenu;
